//get background image
import logoPink from "../assets/logosWhite.png";
//styling
import "../Styling/Logo.css";

function Logo(){
  
    return <img className="logo sm:mt-6" src={logoPink} alt=""/>
}

export default Logo;